$(function () {
  $('.privacy-check .mwform-checkbox-field-text').html('<a href="/privacy/" target="_blank" rel="noopener noreferrer" class="underline">プライバシーポリシー</a>について同意する');
});
